module.exports = __webpack_public_path__ + "img/33_68.f3f51c59.png";